import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { BookFormModule } from '@studiobuki/web-core/lib/book-form';
import { PreviewModule } from '@studiobuki/web-core/lib/preview';
import { SectionMessageDateModule } from '@studiobuki/web-core/lib/section-message-date';
import { SectionReviewsModule } from '@studiobuki/web-core/lib/section-reviews';
import { SectionStepsModule } from '@studiobuki/web-core/lib/section-steps';
import { SectionFaqModule } from '@studiobuki/web-core/lib/section-faq';
import { SectionFooterBannerModule } from 'src/app/shared/section-footer-banner/section-footer-banner.module';
import { SectionFooterBannersModule } from 'src/app/shared/section-footer-banners/section-footer-banners.module';
import { SafePipeModule } from 'safe-pipe';
import { ScrollTopModule } from 'src/app/shared/scroll-top/scroll-top.module';
import { YotpoV3Module } from '@studiobuki/web-core/lib/yotpo-v3';
import { SectionFeaturesModule } from '@studiobuki/web-core/lib/section-features';
import { SectionAboutBannerModule } from 'src/app/shared/section-about-banner/section-about-banner.module';
import { HomePageComponent } from './home-page.component';
import { BannerOneModule } from './components/banner-one/banner-one.module';
import { SectionDescriptionBannerComponent } from './components/section-description-banner/section-description-banner.component';
import { SectionBooksModule } from '../../shared/section-books/section-books.module';

@NgModule({
  declarations: [HomePageComponent, SectionDescriptionBannerComponent],
  imports: [
    CommonModule,
    SectionHeaderGapModule,
    BookFormModule,
    PreviewModule,
    SectionBooksModule,
    SectionMessageDateModule,
    SectionReviewsModule,
    SectionStepsModule,
    SectionFaqModule,
    SectionFooterBannerModule,
    SectionFooterBannersModule,
    SectionFeaturesModule,
    SectionAboutBannerModule,
    BannerOneModule,
    SafePipeModule,
    ScrollTopModule,
    YotpoV3Module,
  ],
})
export class HomePageModule {}
